import { flatten, unique } from './general';

export const TIMEZONES = [
    {
        value: 'Dateline Standard Time',
        abbr: 'DST',
        offset: -12,
        utc: ['Etc/GMT+12'],
    },
    {
        value: 'UTC-11',
        abbr: 'U',
        offset: -11,
        utc: [
            'Etc/GMT+11',
            'Pacific/Midway',
            'Pacific/Niue',
            'Pacific/Pago_Pago',
        ],
    },
    {
        value: 'Hawaiian Standard Time',
        abbr: 'HST',
        offset: -10,
        utc: [
            'Etc/GMT+10',
            'Pacific/Honolulu',
            'Pacific/Johnston',
            'Pacific/Rarotonga',
            'Pacific/Tahiti',
        ],
    },
    {
        value: 'Alaskan Standard Time',
        abbr: 'AKDT',
        offset: -8,
        utc: [
            'America/Anchorage',
            'America/Juneau',
            'America/Nome',
            'America/Sitka',
            'America/Yakutat',
        ],
    },
    {
        value: 'Pacific Standard Time (Mexico)',
        abbr: 'PDT',
        offset: -7,
        utc: ['America/Santa_Isabel'],
    },
    {
        value: 'Pacific Daylight Time',
        abbr: 'PDT',
        offset: -7,
        text: '(UTC-07:00) Pacific Time (US & Canada)',
        utc: [
            'America/Dawson',
            'America/Los_Angeles',
            'America/Tijuana',
            'America/Vancouver',
            'America/Whitehorse',
        ],
    },
    {
        value: 'Pacific Standard Time',
        abbr: 'PST',
        offset: -8,
        text: '(UTC-08:00) Pacific Time (US & Canada)',
        utc: [
            'America/Dawson',
            'America/Los_Angeles',
            'America/Tijuana',
            'America/Vancouver',
            'America/Whitehorse',
            'PST8PDT',
        ],
    },
    {
        value: 'US Mountain Standard Time',
        abbr: 'UMST',
        offset: -7,
        utc: [
            'America/Creston',
            'America/Dawson_Creek',
            'America/Hermosillo',
            'America/Phoenix',
            'Etc/GMT+7',
        ],
    },
    {
        value: 'Mountain Standard Time (Mexico)',
        abbr: 'MDT',
        offset: -6,
        utc: ['America/Chihuahua', 'America/Mazatlan'],
    },
    {
        value: 'Mountain Standard Time',
        abbr: 'MDT',
        offset: -6,
        text: '(UTC-07:00) Mountain Time (US & Canada)',
        utc: [
            'America/Boise',
            'America/Cambridge_Bay',
            'America/Denver',
            'America/Edmonton',
            'America/Inuvik',
            'America/Ojinaga',
            'America/Yellowknife',
            'MST7MDT',
        ],
    },
    {
        value: 'Central America Standard Time',
        abbr: 'CAST',
        offset: -6,
        utc: [
            'America/Belize',
            'America/Costa_Rica',
            'America/El_Salvador',
            'America/Guatemala',
            'America/Managua',
            'America/Tegucigalpa',
            'Etc/GMT+6',
            'Pacific/Galapagos',
        ],
    },
    {
        value: 'Central Standard Time',
        abbr: 'CDT',
        offset: -5,
        text: '(UTC-06:00) Central Time (US & Canada)',
        utc: [
            'America/Chicago',
            'America/Indiana/Knox',
            'America/Indiana/Tell_City',
            'America/Matamoros',
            'America/Menominee',
            'America/North_Dakota/Beulah',
            'America/North_Dakota/Center',
            'America/North_Dakota/New_Salem',
            'America/Rainy_River',
            'America/Rankin_Inlet',
            'America/Resolute',
            'America/Winnipeg',
            'CST6CDT',
        ],
    },
    {
        value: 'Central Standard Time (Mexico)',
        abbr: 'CDT',
        offset: -5,
        utc: [
            'America/Bahia_Banderas',
            'America/Cancun',
            'America/Merida',
            'America/Mexico_City',
            'America/Monterrey',
        ],
    },
    {
        value: 'Canada Central Standard Time',
        abbr: 'CCST',
        offset: -6,
        utc: ['America/Regina', 'America/Swift_Current'],
    },
    {
        value: 'SA Pacific Standard Time',
        abbr: 'SPST',
        offset: -5,
        utc: [
            'America/Bogota',
            'America/Cayman',
            'America/Coral_Harbour',
            'America/Eirunepe',
            'America/Guayaquil',
            'America/Jamaica',
            'America/Lima',
            'America/Panama',
            'America/Rio_Branco',
            'Etc/GMT+5',
        ],
    },
    {
        value: 'Eastern Standard Time',
        abbr: 'EDT',
        offset: -4,
        text: '(UTC-05:00) Eastern Time (US & Canada)',
        utc: [
            'America/Detroit',
            'America/Havana',
            'America/Indiana/Petersburg',
            'America/Indiana/Vincennes',
            'America/Indiana/Winamac',
            'America/Iqaluit',
            'America/Kentucky/Monticello',
            'America/Louisville',
            'America/Montreal',
            'America/Nassau',
            'America/New_York',
            'America/Nipigon',
            'America/Pangnirtung',
            'America/Port-au-Prince',
            'America/Thunder_Bay',
            'America/Toronto',
            'EST5EDT',
        ],
    },
    {
        value: 'US Eastern Standard Time',
        abbr: 'UEDT',
        offset: -4,
        utc: [
            'America/Indiana/Marengo',
            'America/Indiana/Vevay',
            'America/Indianapolis',
        ],
    },
    {
        value: 'Venezuela Standard Time',
        abbr: 'VST',
        offset: -4.5,
        utc: ['America/Caracas'],
    },
    {
        value: 'Paraguay Standard Time',
        abbr: 'PYT',
        offset: -4,
        utc: ['America/Asuncion'],
    },
    {
        value: 'Atlantic Standard Time',
        abbr: 'ADT',
        offset: -3,
        utc: [
            'America/Glace_Bay',
            'America/Goose_Bay',
            'America/Halifax',
            'America/Moncton',
            'America/Thule',
            'Atlantic/Bermuda',
        ],
    },
    {
        value: 'Central Brazilian Standard Time',
        abbr: 'CBST',
        offset: -4,
        utc: ['America/Campo_Grande', 'America/Cuiaba'],
    },
    {
        value: 'SA Western Standard Time',
        abbr: 'SWST',
        offset: -4,
        utc: [
            'America/Anguilla',
            'America/Antigua',
            'America/Aruba',
            'America/Barbados',
            'America/Blanc-Sablon',
            'America/Boa_Vista',
            'America/Curacao',
            'America/Dominica',
            'America/Grand_Turk',
            'America/Grenada',
            'America/Guadeloupe',
            'America/Guyana',
            'America/Kralendijk',
            'America/La_Paz',
            'America/Lower_Princes',
            'America/Manaus',
            'America/Marigot',
            'America/Martinique',
            'America/Montserrat',
            'America/Port_of_Spain',
            'America/Porto_Velho',
            'America/Puerto_Rico',
            'America/Santo_Domingo',
            'America/St_Barthelemy',
            'America/St_Kitts',
            'America/St_Lucia',
            'America/St_Thomas',
            'America/St_Vincent',
            'America/Tortola',
            'Etc/GMT+4',
        ],
    },
    {
        value: 'Pacific SA Standard Time',
        abbr: 'PSST',
        offset: -4,
        utc: ['America/Santiago', 'Antarctica/Palmer'],
    },
    {
        value: 'Newfoundland Standard Time',
        abbr: 'NDT',
        offset: -2.5,
        utc: ['America/St_Johns'],
    },
    {
        value: 'E. South America Standard Time',
        abbr: 'ESAST',
        offset: -3,
        utc: ['America/Sao_Paulo'],
    },
    {
        value: 'Argentina Standard Time',
        abbr: 'AST',
        offset: -3,
        utc: [
            'America/Argentina/La_Rioja',
            'America/Argentina/Rio_Gallegos',
            'America/Argentina/Salta',
            'America/Argentina/San_Juan',
            'America/Argentina/San_Luis',
            'America/Argentina/Tucuman',
            'America/Argentina/Ushuaia',
            'America/Buenos_Aires',
            'America/Catamarca',
            'America/Cordoba',
            'America/Jujuy',
            'America/Mendoza',
        ],
    },
    {
        value: 'SA Eastern Standard Time',
        abbr: 'SEST',
        offset: -3,
        utc: [
            'America/Araguaina',
            'America/Belem',
            'America/Cayenne',
            'America/Fortaleza',
            'America/Maceio',
            'America/Paramaribo',
            'America/Recife',
            'America/Santarem',
            'Antarctica/Rothera',
            'Atlantic/Stanley',
            'Etc/GMT+3',
        ],
    },
    {
        value: 'Greenland Standard Time',
        abbr: 'GDT',
        offset: -3,
        utc: ['America/Godthab'],
    },
    {
        value: 'Montevideo Standard Time',
        abbr: 'MST',
        offset: -3,
        utc: ['America/Montevideo'],
    },
    {
        value: 'Bahia Standard Time',
        abbr: 'BST',
        offset: -3,
        utc: ['America/Bahia'],
    },
    {
        value: 'UTC-02',
        abbr: 'U',
        offset: -2,
        utc: ['America/Noronha', 'Atlantic/South_Georgia', 'Etc/GMT+2'],
    },
    {
        value: 'Mid-Atlantic Standard Time',
        abbr: 'MDT',
        offset: -1,
        utc: [],
    },
    {
        value: 'Azores Standard Time',
        abbr: 'ADT',
        utc: ['America/Scoresbysund', 'Atlantic/Azores'],
    },
    {
        value: 'Cape Verde Standard Time',
        abbr: 'CVST',
        offset: -1,
        text: '(UTC-01:00) Cape Verde Is.',
        utc: ['Atlantic/Cape_Verde', 'Etc/GMT+1'],
    },
    {
        value: 'Morocco Standard Time',
        abbr: 'MDT',
        utc: ['Africa/Casablanca', 'Africa/El_Aaiun'],
    },
    {
        value: 'UTC',
        abbr: 'UTC',
        utc: ['America/Danmarkshavn', 'Etc/GMT'],
    },
    {
        value: 'GMT Standard Time',
        abbr: 'GMT',
        utc: [
            'Europe/Isle_of_Man',
            'Europe/Guernsey',
            'Europe/Jersey',
            'Europe/London',
        ],
    },
    {
        value: 'British Summer Time',
        abbr: 'BST',
        utc: [
            'Europe/Isle_of_Man',
            'Europe/Guernsey',
            'Europe/Jersey',
            'Europe/London',
        ],
    },
    {
        value: 'GMT Standard Time',
        abbr: 'GDT',
        utc: [
            'Atlantic/Canary',
            'Atlantic/Faeroe',
            'Atlantic/Madeira',
            'Europe/Dublin',
            'Europe/Lisbon',
        ],
    },
    {
        value: 'Greenwich Standard Time',
        abbr: 'GST',
        utc: [
            'Africa/Abidjan',
            'Africa/Accra',
            'Africa/Bamako',
            'Africa/Banjul',
            'Africa/Bissau',
            'Africa/Conakry',
            'Africa/Dakar',
            'Africa/Freetown',
            'Africa/Lome',
            'Africa/Monrovia',
            'Africa/Nouakchott',
            'Africa/Ouagadougou',
            'Africa/Sao_Tome',
            'Atlantic/Reykjavik',
            'Atlantic/St_Helena',
        ],
    },
    {
        value: 'W. Europe Standard Time',
        abbr: 'WEDT',
        utc: [
            'Arctic/Longyearbyen',
            'Europe/Amsterdam',
            'Europe/Andorra',
            'Europe/Berlin',
            'Europe/Busingen',
            'Europe/Gibraltar',
            'Europe/Luxembourg',
            'Europe/Malta',
            'Europe/Monaco',
            'Europe/Oslo',
            'Europe/Rome',
            'Europe/San_Marino',
            'Europe/Stockholm',
            'Europe/Vaduz',
            'Europe/Vatican',
            'Europe/Vienna',
            'Europe/Zurich',
        ],
    },
    {
        value: 'Central Europe Standard Time',
        abbr: 'CEDT',
        utc: [
            'Europe/Belgrade',
            'Europe/Bratislava',
            'Europe/Budapest',
            'Europe/Ljubljana',
            'Europe/Podgorica',
            'Europe/Prague',
            'Europe/Tirane',
        ],
    },
    {
        value: 'Romance Standard Time',
        abbr: 'RDT',
        utc: [
            'Africa/Ceuta',
            'Europe/Brussels',
            'Europe/Copenhagen',
            'Europe/Madrid',
            'Europe/Paris',
        ],
    },
    {
        value: 'Central European Standard Time',
        abbr: 'CEDT',
        utc: [
            'Europe/Sarajevo',
            'Europe/Skopje',
            'Europe/Warsaw',
            'Europe/Zagreb',
        ],
    },
    {
        value: 'W. Central Africa Standard Time',
        abbr: 'WCAST',
        utc: [
            'Africa/Algiers',
            'Africa/Bangui',
            'Africa/Brazzaville',
            'Africa/Douala',
            'Africa/Kinshasa',
            'Africa/Lagos',
            'Africa/Libreville',
            'Africa/Luanda',
            'Africa/Malabo',
            'Africa/Ndjamena',
            'Africa/Niamey',
            'Africa/Porto-Novo',
            'Africa/Tunis',
            'Etc/GMT-1',
        ],
    },
    {
        value: 'Namibia Standard Time',
        abbr: 'NST',
        utc: ['Africa/Windhoek'],
    },
    {
        value: 'GTB Standard Time',
        abbr: 'GDT',
        utc: [
            'Asia/Nicosia',
            'Europe/Athens',
            'Europe/Bucharest',
            'Europe/Chisinau',
        ],
    },
    {
        value: 'Middle East Standard Time',
        abbr: 'MEDT',
        utc: ['Asia/Beirut'],
    },
    {
        value: 'Egypt Standard Time',
        abbr: 'EST',
        utc: ['Africa/Cairo'],
    },
    {
        value: 'Syria Standard Time',
        abbr: 'SDT',
        utc: ['Asia/Damascus'],
    },
    {
        value: 'E. Europe Standard Time',
        abbr: 'EEDT',
        text: '(UTC+02:00) E. Europe',
        utc: [
            'Asia/Nicosia',
            'Europe/Athens',
            'Europe/Bucharest',
            'Europe/Chisinau',
            'Europe/Helsinki',
            'Europe/Kiev',
            'Europe/Mariehamn',
            'Europe/Nicosia',
            'Europe/Riga',
            'Europe/Sofia',
            'Europe/Tallinn',
            'Europe/Uzhgorod',
            'Europe/Vilnius',
            'Europe/Zaporozhye',
        ],
    },
    {
        value: 'South Africa Standard Time',
        abbr: 'SAST',
        utc: [
            'Africa/Blantyre',
            'Africa/Bujumbura',
            'Africa/Gaborone',
            'Africa/Harare',
            'Africa/Johannesburg',
            'Africa/Kigali',
            'Africa/Lubumbashi',
            'Africa/Lusaka',
            'Africa/Maputo',
            'Africa/Maseru',
            'Africa/Mbabane',
            'Etc/GMT-2',
        ],
    },
    {
        value: 'FLE Standard Time',
        abbr: 'FDT',
        utc: [
            'Europe/Helsinki',
            'Europe/Kiev',
            'Europe/Mariehamn',
            'Europe/Riga',
            'Europe/Sofia',
            'Europe/Tallinn',
            'Europe/Uzhgorod',
            'Europe/Vilnius',
            'Europe/Zaporozhye',
        ],
    },
    {
        value: 'Turkey Standard Time',
        abbr: 'TDT',
        utc: ['Europe/Istanbul'],
    },
    {
        value: 'Israel Standard Time',
        abbr: 'JDT',
        utc: ['Asia/Jerusalem'],
    },
    {
        value: 'Libya Standard Time',
        abbr: 'LST',
        utc: ['Africa/Tripoli'],
    },
    {
        value: 'Jordan Standard Time',
        abbr: 'JST',
        utc: ['Asia/Amman'],
    },
    {
        value: 'Arabic Standard Time',
        abbr: 'AST',
        utc: ['Asia/Baghdad'],
    },
    {
        value: 'Kaliningrad Standard Time',
        abbr: 'KST',
        utc: ['Europe/Kaliningrad'],
    },
    {
        value: 'Arab Standard Time',
        abbr: 'AST',
        utc: [
            'Asia/Aden',
            'Asia/Bahrain',
            'Asia/Kuwait',
            'Asia/Qatar',
            'Asia/Riyadh',
        ],
    },
    {
        value: 'E. Africa Standard Time',
        abbr: 'EAST',
        utc: [
            'Africa/Addis_Ababa',
            'Africa/Asmera',
            'Africa/Dar_es_Salaam',
            'Africa/Djibouti',
            'Africa/Juba',
            'Africa/Kampala',
            'Africa/Khartoum',
            'Africa/Mogadishu',
            'Africa/Nairobi',
            'Antarctica/Syowa',
            'Etc/GMT-3',
            'Indian/Antananarivo',
            'Indian/Comoro',
            'Indian/Mayotte',
        ],
    },
    {
        value: 'Moscow Standard Time',
        abbr: 'MSK',
        text: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
        utc: [
            'Europe/Kirov',
            'Europe/Moscow',
            'Europe/Simferopol',
            'Europe/Volgograd',
            'Europe/Minsk',
        ],
    },
    {
        value: 'Samara Time',
        abbr: 'SAMT',
        utc: ['Europe/Astrakhan', 'Europe/Samara', 'Europe/Ulyanovsk'],
    },
    {
        value: 'Iran Standard Time',
        abbr: 'IDT',
        utc: ['Asia/Tehran'],
    },
    {
        value: 'Arabian Standard Time',
        abbr: 'AST',
        utc: ['Asia/Dubai', 'Asia/Muscat', 'Etc/GMT-4'],
    },
    {
        value: 'Azerbaijan Standard Time',
        abbr: 'ADT',
        utc: ['Asia/Baku'],
    },
    {
        value: 'Mauritius Standard Time',
        abbr: 'MST',
        utc: ['Indian/Mahe', 'Indian/Mauritius', 'Indian/Reunion'],
    },
    {
        value: 'Georgian Standard Time',
        abbr: 'GET',
        utc: ['Asia/Tbilisi'],
    },
    {
        value: 'Caucasus Standard Time',
        abbr: 'CST',
        utc: ['Asia/Yerevan'],
    },
    {
        value: 'Afghanistan Standard Time',
        abbr: 'AST',
        utc: ['Asia/Kabul'],
    },
    {
        value: 'West Asia Standard Time',
        abbr: 'WAST',
        utc: [
            'Antarctica/Mawson',
            'Asia/Aqtau',
            'Asia/Aqtobe',
            'Asia/Ashgabat',
            'Asia/Dushanbe',
            'Asia/Oral',
            'Asia/Samarkand',
            'Asia/Tashkent',
            'Etc/GMT-5',
            'Indian/Kerguelen',
            'Indian/Maldives',
        ],
    },
    {
        value: 'Yekaterinburg Time',
        abbr: 'YEKT',
        utc: ['Asia/Yekaterinburg'],
    },
    {
        value: 'Pakistan Standard Time',
        abbr: 'PKT',
        utc: ['Asia/Karachi'],
    },
    {
        value: 'India Standard Time',
        abbr: 'IST',
        utc: ['Asia/Kolkata'],
    },
    {
        value: 'Sri Lanka Standard Time',
        abbr: 'SLST',
        utc: ['Asia/Colombo'],
    },
    {
        value: 'Nepal Standard Time',
        abbr: 'NST',
        utc: ['Asia/Kathmandu'],
    },
    {
        value: 'Central Asia Standard Time',
        abbr: 'CAST',
        utc: [
            'Antarctica/Vostok',
            'Asia/Almaty',
            'Asia/Bishkek',
            'Asia/Qyzylorda',
            'Asia/Urumqi',
            'Etc/GMT-6',
            'Indian/Chagos',
        ],
    },
    {
        value: 'Bangladesh Standard Time',
        abbr: 'BST',
        utc: ['Asia/Dhaka', 'Asia/Thimphu'],
    },
    {
        value: 'Myanmar Standard Time',
        abbr: 'MST',
        utc: ['Asia/Rangoon', 'Indian/Cocos'],
    },
    {
        value: 'SE Asia Standard Time',
        abbr: 'SAST',
        utc: [
            'Antarctica/Davis',
            'Asia/Bangkok',
            'Asia/Hovd',
            'Asia/Jakarta',
            'Asia/Phnom_Penh',
            'Asia/Pontianak',
            'Asia/Saigon',
            'Asia/Vientiane',
            'Etc/GMT-7',
            'Indian/Christmas',
        ],
    },
    {
        value: 'N. Central Asia Standard Time',
        abbr: 'NCAST',
        utc: ['Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk'],
    },
    {
        value: 'China Standard Time',
        abbr: 'CST',
        utc: ['Asia/Hong_Kong', 'Asia/Macau', 'Asia/Shanghai'],
    },
    {
        value: 'North Asia Standard Time',
        abbr: 'NAST',
        utc: ['Asia/Krasnoyarsk'],
    },
    {
        value: 'Singapore Standard Time',
        abbr: 'MPST',
        utc: [
            'Asia/Brunei',
            'Asia/Kuala_Lumpur',
            'Asia/Kuching',
            'Asia/Makassar',
            'Asia/Manila',
            'Asia/Singapore',
            'Etc/GMT-8',
        ],
    },
    {
        value: 'W. Australia Standard Time',
        abbr: 'WAST',
        utc: ['Antarctica/Casey', 'Australia/Perth'],
    },
    {
        value: 'Taipei Standard Time',
        abbr: 'TST',
        utc: ['Asia/Taipei'],
    },
    {
        value: 'Ulaanbaatar Standard Time',
        abbr: 'UST',
        utc: ['Asia/Choibalsan', 'Asia/Ulaanbaatar'],
    },
    {
        value: 'North Asia East Standard Time',
        abbr: 'NAEST',
        utc: ['Asia/Irkutsk'],
    },
    {
        value: 'Japan Standard Time',
        abbr: 'JST',
        utc: [
            'Asia/Dili',
            'Asia/Jayapura',
            'Asia/Tokyo',
            'Etc/GMT-9',
            'Pacific/Palau',
        ],
    },
    {
        value: 'Korea Standard Time',
        abbr: 'KST',
        utc: ['Asia/Pyongyang', 'Asia/Seoul'],
    },
    {
        value: 'Cen. Australia Standard Time',
        abbr: 'CAST',
        utc: ['Australia/Adelaide', 'Australia/Broken_Hill'],
    },
    {
        value: 'AUS Central Standard Time',
        abbr: 'ACST',
        utc: ['Australia/Darwin'],
    },
    {
        value: 'E. Australia Standard Time',
        abbr: 'EAST',
        utc: ['Australia/Brisbane', 'Australia/Lindeman'],
    },
    {
        value: 'AUS Eastern Standard Time',
        abbr: 'AEST',
        utc: ['Australia/Melbourne', 'Australia/Sydney'],
    },
    {
        value: 'West Pacific Standard Time',
        abbr: 'WPST',
        utc: [
            'Antarctica/DumontDUrville',
            'Etc/GMT-10',
            'Pacific/Guam',
            'Pacific/Port_Moresby',
            'Pacific/Saipan',
            'Pacific/Truk',
        ],
    },
    {
        value: 'Tasmania Standard Time',
        abbr: 'TST',
        utc: ['Australia/Currie', 'Australia/Hobart'],
    },
    {
        value: 'Yakutsk Standard Time',
        abbr: 'YST',
        utc: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk'],
    },
    {
        value: 'Central Pacific Standard Time',
        abbr: 'CPST',
        text: '(UTC+11:00) Solomon Is., New Caledonia',
        utc: [
            'Antarctica/Macquarie',
            'Etc/GMT-11',
            'Pacific/Efate',
            'Pacific/Guadalcanal',
            'Pacific/Kosrae',
            'Pacific/Noumea',
            'Pacific/Ponape',
        ],
    },
    {
        value: 'Vladivostok Standard Time',
        abbr: 'VST',
        utc: ['Asia/Sakhalin', 'Asia/Ust-Nera', 'Asia/Vladivostok'],
    },
    {
        value: 'New Zealand Standard Time',
        abbr: 'NZST',
        utc: ['Antarctica/McMurdo', 'Pacific/Auckland'],
    },
    {
        value: 'UTC+12',
        abbr: 'U',
        utc: [
            'Etc/GMT-12',
            'Pacific/Funafuti',
            'Pacific/Kwajalein',
            'Pacific/Majuro',
            'Pacific/Nauru',
            'Pacific/Tarawa',
            'Pacific/Wake',
            'Pacific/Wallis',
        ],
    },
    {
        value: 'Fiji Standard Time',
        abbr: 'FST',
        utc: ['Pacific/Fiji'],
    },
    {
        value: 'Magadan Standard Time',
        abbr: 'MST',
        utc: [
            'Asia/Anadyr',
            'Asia/Kamchatka',
            'Asia/Magadan',
            'Asia/Srednekolymsk',
        ],
    },
    {
        value: 'Kamchatka Standard Time',
        abbr: 'KDT',
        utc: ['Asia/Kamchatka'],
    },
    {
        value: 'Tonga Standard Time',
        abbr: 'TST',
        utc: [
            'Etc/GMT-13',
            'Pacific/Enderbury',
            'Pacific/Fakaofo',
            'Pacific/Tongatapu',
        ],
    },
    {
        value: 'Samoa Standard Time',
        abbr: 'SST',
        utc: ['Pacific/Apia'],
    },
];

export const TIMEZONES_IANA = unique(
    flatten(TIMEZONES.map((_) => _.utc)),
).sort();
